import React from 'react';
import cn from 'classnames';

import { useTranslation } from 'providers/GILT.provider';

import CN from './ItemFooter.module.scss';

const Footer = ({ markAsRead, timestamp, seen }) => {
  const { t } = useTranslation();
  const markedAsRead = cn({
    [CN.markedAsRead]: seen,
    [CN.highlighted]: !seen,
  });
  return (
    <div data-bem="Footer" className={CN.cfix}>
      <div className={CN.actionLinks}>
        <div className={CN.feedTime}>{timestamp}</div>
        <div />
        <div className={markedAsRead} onClick={markAsRead} role="button" tabIndex="0">
          <span>
            <div>
              {seen
                ? t('composite.activityFeed.bookingItem.markAsUnread')
                : t('composite.activityFeed.bookingItem.markAsRead')}
            </div>
          </span>
        </div>
      </div>
    </div>
  );
};

export default Footer;
